<template>
  <svg viewBox="0 0 242.5 49.3" class="logo">
    <polygon points="51.6,23.2 51.8,23.6 55.2,23.6 54.9,22.7 "/>
    <polygon points="54.4,21.5 51.1,22 51.3,22.5 54.6,22 "/>
    <polygon points="56.4,23.6 59.7,23.6 59.7,22 56.4,22.5 "/>
    <polygon points="53.8,20.3 50.6,20.8 50.8,21.3 54.1,20.8 "/>
    <polygon points="53.3,19 50.1,19.6 50.3,20.1 53.5,19.6 "/>
    <polygon points="58.8,0.4 56.4,0.4 56.4,16.5 59.7,16 59.7,6.5 66.6,14.9 70.2,14.3 "/>
    <polygon points="56.4,17.8 59.7,17.3 59.7,16.8 56.4,17.3 "/>
    <polygon points="56.4,19.1 59.7,18.6 59.7,18 56.4,18.6 "/>
    <polygon points="56.4,21.7 59.7,21.2 59.7,20.6 56.4,21.2 "/>
    <polygon points="56.4,20.4 59.7,19.9 59.7,19.3 56.4,19.9 "/>
    <polygon points="70.7,15 67.1,15.6 67.5,16 71.1,15.5 "/>
    <path d="M26.7,23.6c1.9,0,3.2-0.4,4.3-1l-6.5,1H26.7z"/>
    <polygon points="52.8,17.8 49.6,18.4 49.8,18.8 53,18.3 "/>
    <path d="M30.6,10.6c1.1-1,1.8-2.6,1.8-4.1c0-1.7-0.7-3.3-1.9-4.4c-1.1-1-2.5-1.6-4.8-1.6h-7.9v23.2h1.9l12.6-2
      c1.3-1.3,2.1-3,2.1-4.9C34.4,14,32.8,11.6,30.6,10.6z M21.1,3.5h4c1.9,0,2.7,0.4,3.2,1c0.5,0.5,0.8,1.2,0.8,2s-0.3,1.5-0.8,2
      c-0.5,0.6-1.3,1-3.2,1h-4V3.5z M30,19.3c-0.7,0.7-1.7,1.2-3.8,1.2h-5v-7.8h5c2.1,0,3.1,0.5,3.8,1.2c0.7,0.7,1.1,1.6,1.1,2.7
      C31.1,17.6,30.6,18.6,30,19.3z"/>
    <polygon points="34.6,21.2 38.3,20.7 38.5,20.1 34.9,20.7 "/>
    <path d="M45.6,0.4h-2.3l-8.1,19.5l3.7-0.6l0,0l10.4-1.7l0,0l3.2-0.5L45.6,0.4z M40.2,16.1l4.2-10.3l3.7,8.9L40.2,16.1z"/>
    <polygon points="33.7,23.6 36.2,23.6 37.2,23.5 37.4,22.9 33.7,23.5 "/>
    <polygon points="34,22.6 37.7,22.1 38,21.5 34.3,22.1 "/>
    <polygon points="86.4,13 89.8,12.5 89.8,12 86.4,12.5 "/>
    <path d="M152.5,11.3c1.4-1.2,2.3-2.8,2.3-4.7s-0.8-3.7-2.3-4.7c-1-0.8-2.4-1.4-4.5-1.4h-8.1v23.1h3.3V12.7h2.6l8.2,10.9h4l-8.3-11
      C151,12.3,151.8,11.9,152.5,11.3z M143.3,9.5v-6h4.6c1.5,0,2.2,0.3,2.7,0.8s0.8,1.3,0.8,2.1s-0.3,1.6-0.8,2.1
      c-0.5,0.5-1.3,0.8-2.7,0.8L143.3,9.5L143.3,9.5z"/>
    <path d="M114,10.6l-0.1-0.5l0.6-0.1c-0.2-0.9-0.4-1.7-0.7-2.5l-0.5,0.2l-0.2-0.5l0.5-0.2c-0.4-0.8-0.8-1.5-1.3-2.2l-0.5,0.4
      l-0.3-0.4l0.5-0.4c-0.6-0.7-1.2-1.3-1.9-1.8l-0.4,0.6l-0.4-0.3l0.4-0.6c-0.7-0.5-1.5-0.9-2.3-1.3l-0.3,0.7l-0.5-0.2l0.3-0.7
      c-0.8-0.3-1.7-0.5-2.5-0.6l-0.1,0.7l-0.5-0.1l0.1-0.6c-0.8-0.1-1.7,0-2.6,0.1l0.1,0.7l-0.5,0.1l-0.1-0.7c-0.9,0.2-1.7,0.4-2.5,0.8
      l0.3,0.6L98.1,2l-0.2-0.6c-0.8,0.4-1.5,0.8-2.2,1.4l0.4,0.5l-0.4,0.3l-0.4-0.5c-0.6,0.6-1.2,1.2-1.7,1.9l0.5,0.3l-0.3,0.4l-0.4-0.3
      c-0.5,0.7-0.8,1.5-1.1,2.3l0.4,0.2l-0.2,0.5L92,8.2c-0.3,0.9-0.5,1.8-0.5,2.8l3.4-0.5c0.6-3.6,3.1-6.4,6.8-7
      c4.7-0.8,8.8,2.4,9.6,7.4c0.8,5-2.1,9.2-6.8,10c-3.7,0.6-7.1-1.3-8.7-4.6l-3.4,0.5c0.4,0.9,0.8,1.7,1.3,2.5l0.4-0.3l0.3,0.4L94,19.7
      c0.5,0.7,1.1,1.3,1.8,1.8l0.4-0.5l0.4,0.3l-0.4,0.5c0.7,0.5,1.4,1,2.2,1.3l0.3-0.7l0.5,0.2l-0.3,0.7c0.8,0.3,1.7,0.5,2.5,0.6
      l0.1-0.8l0.5,0.1l-0.1,0.8c0.9,0.1,1.7,0.1,2.6-0.1l-0.1-0.8l0.5-0.1l0.1,0.8c0.9-0.2,1.7-0.4,2.5-0.7l-0.4-0.8l0.5-0.2l0.4,0.8
      c0.8-0.4,1.6-0.8,2.3-1.4l-0.6-0.7l0.4-0.3l0.6,0.7c0.7-0.6,1.3-1.2,1.8-1.9l-0.7-0.5l0.3-0.4l0.7,0.5c0.5-0.7,0.9-1.5,1.2-2.3
      l-0.7-0.3l0.2-0.5l0.7,0.3c0.3-0.8,0.4-1.7,0.5-2.5l-0.6-0.1l0.1-0.5l0.6,0.1c0-0.8,0-1.7-0.1-2.6L114,10.6z"/>
    <path d="M135.6,2c-1.2-0.9-2.5-1.5-4.8-1.5h-8.7v23.1h3.3V13.4h5.5c2.2,0,3.7-0.5,4.8-1.5C137,10.8,138,9,138,7
      C138,4.9,137,3.1,135.6,2z M133.7,9.2c-0.6,0.6-1.5,1-3,1h-5.2V3.6h5.2c1.6,0,2.4,0.4,3,1c0.5,0.6,0.9,1.4,0.9,2.3
      C134.6,7.7,134.3,8.6,133.7,9.2z"/>
    <path d="M95.3,15l-3.4,0.6c0.1,0.2,0.1,0.3,0.2,0.5l3.3-0.5C95.4,15.4,95.3,15.2,95.3,15z"/>
    <path d="M94.9,13.8l-3.3,0.5c0,0.2,0.1,0.3,0.1,0.5l3.3-0.5C95,14.1,95,14,94.9,13.8z"/>
    <path d="M94.8,12.5L91.5,13c0,0.2,0,0.4,0.1,0.5l3.3-0.5C94.8,12.9,94.8,12.7,94.8,12.5z"/>
    <path d="M94.8,11.2l-3.3,0.5c0,0.2,0,0.4,0,0.5l3.3-0.5C94.8,11.6,94.8,11.4,94.8,11.2z"/>
    <path d="M168.3,0.1c-6.5,0-11.5,5.1-11.5,11.9s5,11.9,11.5,11.9c6.5,0,11.5-5.1,11.5-11.9S174.8,0.1,168.3,0.1z M168.3,20.7
      c-4.7,0-8.3-3.8-8.3-8.7s3.6-8.7,8.3-8.7c4.7,0,8.3,3.8,8.3,8.7S173,20.7,168.3,20.7z"/>
    <polygon points="71.7,16.2 68.1,16.7 68.5,17.2 72,16.6 "/>
    <path d="M186.9,16.8c0,1.4-0.2,2.1-0.6,2.6c-0.5,0.7-1.6,1.3-2.6,1.3c-1.4,0-2.5-0.7-3-1.8c-0.5,1-1.3,1.9-2.1,2.6
      c1.2,1.5,3,2.3,5.1,2.3c2.4,0,4.6-1.4,5.8-3.4c0.5-0.9,0.8-2.1,0.8-3.9V0.5H187L186.9,16.8L186.9,16.8z"/>
    <polygon points="196.8,12.7 204.3,12.7 204.3,9.5 196.8,9.5 196.8,3.5 206.6,3.5 206.6,0.5 193.5,0.5 193.5,23.5 207,23.5 207,20.4
      196.8,20.4 "/>
    <polygon points="72.7,16.5 76,16 76,15.5 72.7,16 "/>
    <polygon points="72.7,17.4 72.6,17.3 69,17.9 69.4,18.4 76,17.3 76,16.8 72.7,17.3 "/>
    <polygon points="86.4,11.7 89.8,11.2 89.8,0.4 86.4,0.4 "/>
    <polygon points="70.3,19.5 76,18.6 76,18.1 70,19 "/>
    <polygon points="72.7,15.2 76,14.7 76,14.2 72.7,14.7 "/>
    <polygon points="73.7,23.6 76,23.6 76,19.4 70.9,20.2 "/>
    <polygon points="86.4,14.4 89.8,13.8 89.8,13.3 86.4,13.8 "/>
    <polygon points="72.7,13.9 76,13.4 76,0.4 72.7,0.4 "/>
    <polygon points="86.4,15.7 89.8,15.1 89.8,14.6 86.4,15.1 "/>
    <path d="M85.8,19.5c-0.6,0.8-1.6,1.3-2.6,1.3s-1.9-0.4-2.5-1l-3.5,0.5c1,2.3,3.3,3.6,6,3.6c2.5,0,4.6-1.4,5.8-3.4
      c0.5-0.9,0.7-1.9,0.8-3.4l-3.3,0.5C86.3,18.6,86.1,19.1,85.8,19.5z"/>
    <path d="M86.4,16.9V17l3.3-0.5V16l-3.3,0.5V16.9L86.4,16.9z"/>
    <polygon points="226.7,0.8 226.7,3.9 233,3.9 233,23.9 236.3,23.9 236.3,3.9 242.5,3.9 242.5,0.8 "/>
    <path d="M224.6,18.6c-1.4,1.3-3.3,2.4-5.9,2.4c-4.9,0-8.7-3.6-8.7-8.7c0-4.9,3.7-8.7,8.4-8.7c2.4,0,4.8,1,6.2,2.5v-4
      c-1.8-1-3.9-1.7-6.2-1.7c-6.6,0-11.6,5.2-11.6,11.9c0,6.8,5,11.9,12,11.9c2.1,0,4.1-0.6,5.9-1.6V18.6L224.6,18.6z"/>
    <g>
      <polygon points="5.6,5.1 5.6,1.6 4.2,1.6 4.2,5.1 1.4,5.1 1.4,0.5 0,0.5 0,6.6 10.7,6.6 10.7,0.4 9.2,0.4 9.2,5.1"/>
      <polygon points="1.4,23.6 1.4,20.7 10.7,20.7 10.7,19.2 1.4,19.2 1.4,16.3 0,16.3 0,23.6"/>
      <polygon points="4.2,9.5 4.2,13.6 0,13.6 0,15.1 10.7,15.1 10.7,13.6 5.7,13.6 5.7,9.5 10.7,9.5 10.7,8 0,8 0,9.5"/>
    </g>
    <g>
      <path d="M3.7,48.8c-1.5,0-2.8-0.7-3.7-1.7L1.1,46c0.7,0.8,1.7,1.2,2.7,1.2c1.5,0,2.2-0.5,2.2-1.5c0-0.8-0.6-1.2-2.4-1.7
        c-2.2-0.7-3.3-1.2-3.3-3.1c0-1.8,1.5-2.9,3.5-2.9c1.4,0,2.5,0.5,3.4,1.4l-1.1,1.1c-0.7-0.7-1.4-1-2.4-1c-1.2,0-1.8,0.6-1.8,1.3
        c0,0.7,0.5,1.1,2.3,1.6c2.1,0.6,3.4,1.3,3.4,3.2C7.6,47.5,6.4,48.8,3.7,48.8z"/>
      <path d="M14,48.4c-0.4,0.2-0.9,0.4-1.5,0.4c-1.1,0-1.8-0.7-1.8-2.1v-4.5H9.6v-1.4h1.1v-2.2l1.5-0.8v3.1h2v1.4h-2v4.3
        c0,0.7,0.2,0.9,0.8,0.9c0.4,0,0.9-0.1,1.1-0.3L14,48.4z"/>
      <path d="M19.9,48.8c-2,0-3.5-1.6-3.5-4.1c0-2.6,1.5-4.1,3.5-4.1c2,0,3.5,1.6,3.5,4.1C23.4,47.3,21.9,48.8,19.9,48.8z M19.8,42.1
        c-1.2,0-1.9,1-1.9,2.6c0,1.7,0.8,2.7,2,2.7s1.9-1.2,1.9-2.6C21.9,43.1,21.1,42.1,19.8,42.1z"/>
      <path d="M30.3,42.4c-0.3-0.2-0.7-0.3-1.2-0.3c-1,0-1.5,0.7-1.5,2v4.5h-1.5v-7.9h1.5v0.8c0.4-0.5,1-0.9,1.8-0.9c0.6,0,1,0.1,1.3,0.3
        L30.3,42.4z"/>
      <path d="M33.9,39.7c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1c0.5,0,1,0.5,1,1C34.9,39.3,34.5,39.7,33.9,39.7z M33.2,48.6v-7.9h1.5v7.9
        H33.2z"/>
      <path d="M44.2,45.2H39c0.2,1.5,1,2.2,2,2.2c0.7,0,1.2-0.2,1.7-0.6l0.9,1c-0.7,0.7-1.5,1-2.7,1c-1.8,0-3.4-1.5-3.4-4.1
        c0-2.7,1.4-4.1,3.4-4.1c2.2,0,3.3,1.8,3.3,3.9C44.2,44.8,44.2,45.1,44.2,45.2z M40.8,42c-1,0-1.7,0.7-1.8,2h3.7
        C42.6,42.9,42.1,42,40.8,42z"/>
      <path d="M49.3,48.8c-1.1,0-2.2-0.4-3-1l0.7-1.2c0.7,0.5,1.6,0.8,2.3,0.8c1,0,1.4-0.3,1.4-0.9c0-0.6-0.7-0.9-1.8-1.3
        c-1.7-0.7-2.3-1.2-2.3-2.5c0-1.4,1.1-2.1,2.7-2.1c1,0,2,0.4,2.7,0.9l-0.7,1.2c-0.6-0.5-1.3-0.7-2-0.7s-1.1,0.3-1.1,0.7
        c0,0.4,0.3,0.7,1.5,1.1c1.8,0.7,2.7,1.2,2.7,2.6C52.2,48.2,50.8,48.8,49.3,48.8z"/>
      <path d="M62.8,48.8c-2,0-3.5-1.6-3.5-4.1c0-2.6,1.5-4.1,3.5-4.1c2,0,3.5,1.6,3.5,4.1C66.4,47.3,64.9,48.8,62.8,48.8z M62.8,42.1
        c-1.2,0-1.9,1-1.9,2.6c0,1.7,0.8,2.7,2,2.7s1.9-1.2,1.9-2.6C64.8,43.1,64.1,42.1,62.8,42.1z"/>
      <path d="M71.6,39.1c-0.5,0-0.7,0.2-0.7,0.8v0.9h1.5v1.4h-1.5v6.4h-1.5v-6.4h-1v-1.4h1v-1c0-1.4,0.9-2,2-2c0.4,0,0.8,0.1,1.2,0.2
        v1.3C72.2,39.1,71.9,39.1,71.6,39.1z"/>
      <path d="M87,48.6l-0.9-2.5h-4.2L81,48.6h-1.6l3.8-10.5h1.7l3.8,10.5H87z M84.8,42.3c-0.3-0.8-0.7-2-0.8-2.4
        c-0.1,0.5-0.5,1.6-0.8,2.4l-0.8,2.4h3.2L84.8,42.3z"/>
      <path d="M100.4,48.6v-4.5c0-1.6-0.5-2.2-1.5-2.2c-1,0-1.5,0.7-1.5,2v4.6h-1.5v-4.5c0-1.6-0.5-2.2-1.5-2.2c-1,0-1.5,0.7-1.5,2v4.6
        h-1.5v-7.9h1.5v0.8c0.4-0.6,1.1-0.9,1.9-0.9c1.1,0,1.7,0.4,2.2,1.2c0.6-0.7,1.2-1.2,2.4-1.2c1.8,0,2.7,1.2,2.7,3.5v4.5H100.4z"/>
      <path d="M111.3,45.2H106c0.2,1.5,1,2.2,2,2.2c0.7,0,1.2-0.2,1.7-0.6l0.9,1c-0.7,0.7-1.5,1-2.7,1c-1.8,0-3.4-1.5-3.4-4.1
        c0-2.7,1.4-4.1,3.5-4.1c2.2,0,3.3,1.8,3.3,3.9C111.3,44.8,111.3,45.1,111.3,45.2z M107.9,42c-1,0-1.7,0.7-1.8,2h3.7
        C109.7,42.9,109.2,42,107.9,42z"/>
      <path d="M118.2,42.4c-0.3-0.2-0.7-0.3-1.2-0.3c-1,0-1.5,0.7-1.5,2v4.5H114v-7.9h1.5v0.8c0.4-0.5,1-0.9,1.8-0.9c0.6,0,1,0.1,1.3,0.3
        L118.2,42.4z"/>
      <path d="M121.8,39.7c-0.6,0-1-0.5-1-1c0-0.6,0.4-1,1-1c0.5,0,1,0.5,1,1C122.8,39.3,122.4,39.7,121.8,39.7z M121.1,48.6v-7.9h1.5
        v7.9H121.1z"/>
      <path d="M130.7,43c-0.6-0.7-1.2-1-1.9-1c-1.1,0-1.8,1-1.8,2.6c0,1.5,0.7,2.7,1.9,2.7c0.7,0,1.2-0.3,1.8-1l1,1
        c-0.6,0.8-1.4,1.5-2.8,1.5c-1.9,0-3.4-1.6-3.4-4.1c0-2.6,1.5-4.1,3.5-4.1c1.2,0,2.1,0.5,2.8,1.3L130.7,43z"/>
      <path d="M138.6,48.6v-0.8c-0.5,0.5-1.3,0.9-2.2,0.9c-1.3,0-2.7-0.7-2.7-2.7c0-1.8,1.4-2.5,3.1-2.5c0.7,0,1.3,0.1,1.8,0.3v-0.6
        c0-0.9-0.5-1.3-1.5-1.3c-0.8,0-1.4,0.2-2.1,0.5l-0.6-1.2c0.8-0.5,1.6-0.7,2.7-0.7c1.8,0,3,0.9,3,2.6v5.4H138.6z M138.6,45.3
        c-0.4-0.2-1-0.3-1.8-0.3c-1,0-1.6,0.5-1.6,1.2c0,0.8,0.5,1.3,1.5,1.3c0.8,0,1.5-0.5,1.9-1V45.3z"/>
      <path d="M143.9,41.9h-1l0.2-3.8h2L143.9,41.9z"/>
      <path d="M149.6,48.8c-1.1,0-2.2-0.4-3-1l0.7-1.2c0.7,0.5,1.6,0.8,2.3,0.8c1,0,1.4-0.3,1.4-0.9c0-0.6-0.7-0.9-1.8-1.3
        c-1.7-0.7-2.3-1.2-2.3-2.5c0-1.4,1.1-2.1,2.7-2.1c1,0,2,0.4,2.7,0.9l-0.7,1.2c-0.6-0.5-1.3-0.7-2-0.7s-1.1,0.3-1.1,0.7
        c0,0.4,0.3,0.7,1.5,1.1c1.8,0.7,2.7,1.2,2.7,2.6C152.5,48.2,151.1,48.8,149.6,48.8z"/>
      <path d="M160.3,48.6V38.1h1.6v10.5H160.3z"/>
      <path d="M170,48.6v-4.5c0-1.6-0.6-2.2-1.6-2.2c-1,0-1.6,0.7-1.6,2v4.6h-1.5v-7.9h1.5v0.8c0.4-0.6,1.2-0.9,2-0.9
        c1.8,0,2.8,1.2,2.8,3.5v4.5H170z"/>
      <path d="M177.1,48.8c-1.1,0-2.2-0.4-3-1l0.7-1.2c0.7,0.5,1.6,0.8,2.3,0.8c1,0,1.4-0.3,1.4-0.9c0-0.6-0.7-0.9-1.8-1.3
        c-1.7-0.7-2.3-1.2-2.3-2.5c0-1.4,1.1-2.1,2.7-2.1c1,0,2,0.4,2.7,0.9l-0.7,1.2c-0.6-0.5-1.3-0.7-2-0.7s-1.1,0.3-1.1,0.7
        c0,0.4,0.3,0.7,1.5,1.1c1.8,0.7,2.7,1.2,2.7,2.6C180.1,48.2,178.6,48.8,177.1,48.8z"/>
      <path d="M186.4,48.4c-0.4,0.2-0.9,0.4-1.5,0.4c-1.1,0-1.8-0.7-1.8-2.1v-4.5H182v-1.4h1.1v-2.2l1.5-0.8v3.1h2v1.4h-2v4.3
        c0,0.7,0.2,0.9,0.8,0.9c0.4,0,0.9-0.1,1.1-0.3L186.4,48.4z"/>
      <path d="M193.7,42.4c-0.3-0.2-0.7-0.3-1.2-0.3c-1,0-1.5,0.7-1.5,2v4.5h-1.5v-7.9h1.5v0.8c0.4-0.5,1-0.9,1.8-0.9
        c0.6,0,1,0.1,1.3,0.3L193.7,42.4z"/>
      <path d="M201.2,48.6v-0.8c-0.4,0.6-1.2,0.9-2,0.9c-1.8,0-2.8-1.2-2.8-3.5v-4.5h1.5v4.5c0,1.6,0.6,2.2,1.6,2.2c1,0,1.6-0.7,1.6-2
        v-4.6h1.5v7.9H201.2z"/>
      <path d="M214.9,48.6v-4.5c0-1.6-0.5-2.2-1.5-2.2c-1,0-1.5,0.7-1.5,2v4.6h-1.5v-4.5c0-1.6-0.5-2.2-1.5-2.2c-1,0-1.5,0.7-1.5,2v4.6
        h-1.5v-7.9h1.5v0.8c0.4-0.6,1.1-0.9,1.9-0.9c1.1,0,1.7,0.4,2.2,1.2c0.6-0.7,1.2-1.2,2.4-1.2c1.8,0,2.7,1.2,2.7,3.5v4.5H214.9z"/>
      <path d="M225.8,45.2h-5.2c0.2,1.5,1,2.2,2,2.2c0.7,0,1.2-0.2,1.7-0.6l0.9,1c-0.7,0.7-1.5,1-2.7,1c-1.8,0-3.4-1.5-3.4-4.1
        c0-2.7,1.4-4.1,3.5-4.1c2.2,0,3.3,1.8,3.3,3.9C225.8,44.8,225.8,45.1,225.8,45.2z M222.4,42c-1,0-1.7,0.7-1.8,2h3.7
        C224.2,42.9,223.7,42,222.4,42z"/>
      <path d="M233.3,48.6v-4.5c0-1.6-0.6-2.2-1.6-2.2c-1,0-1.6,0.7-1.6,2v4.6h-1.5v-7.9h1.5v0.8c0.4-0.6,1.2-0.9,2-0.9
        c1.8,0,2.8,1.2,2.8,3.5v4.5H233.3z"/>
      <path d="M241.5,48.4c-0.4,0.2-0.9,0.4-1.5,0.4c-1.1,0-1.8-0.7-1.8-2.1v-4.5h-1.1v-1.4h1.1v-2.2l1.5-0.8v3.1h2v1.4h-2v4.3
        c0,0.7,0.2,0.9,0.8,0.9c0.4,0,0.9-0.1,1.1-0.3L241.5,48.4z"/>
    </g>
    <!-- <line class="st0" x1="0" y1="31.8" x2="242.5" y2="31.8"/> -->
  </svg>
</template>

<!--/////////////////////////////////////////////////////////////////////////-->

<script>
export default {
  name: 'logo-horizontal'
}
</script>

<!--/////////////////////////////////////////////////////////////////////////-->

<style scoped lang="scss">
svg {
  fill: currentColor;
}

// line {
//   stroke: currentColor;
// }
</style>
